
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function ServicesOverview() {
  const navigate = useNavigate();

  const services = [
    {
      icon: 'ri-car-line',
      title: '車検整備',
      description: '国の認証工場として、安心・確実な車検を実施。経験豊富な整備士が丁寧に点検いたします。',
      image: 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=400&q=80',
      buttonText: '車検の流れを見る',
      action: () => navigate('/inspection-flow')
    },
    {
      icon: 'ri-hammer-line',
      title: '鈑金・塗装',
      description: '小さなキズから大きな修復まで対応。仕上がり品質に自信があります。お車を美しく蘇らせます。',
      image: 'https://images.unsplash.com/photo-1619642751034-765dfdf7c58e?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      buttonText: '詳細を見る',
      action: () => navigate('/services')
    },
    {
      icon: 'ri-exchange-line',
      title: '乗り換えサポート',
      description: '中古車・新車販売も対応。整備工場ならではの安心保証付きで、お客様の乗り換えをサポートします。',
      image: 'https://images.unsplash.com/photo-1549317661-bd32c8ce0db2?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
      buttonText: '詳細を見る',
      action: () => navigate('/services')
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-4">
            クルマのこと、すべてお任せください。
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            地域密着の自動車整備工場として、お客様の大切なお車を責任を持ってお預かりいたします。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mr-4">
                    <i className={`${service.icon} text-2xl text-orange-500`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-slate-800">{service.title}</h3>
                </div>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {service.description}
                </p>
                <Button 
                  variant="outline" 
                  onClick={service.action}
                  className="w-full"
                >
                  {service.buttonText}
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
